import { faMusic } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "components/Loader/Loader";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { IResourcesAlarm } from "../domain/IResourceAlarm";
import { selectState } from "../slices/dtResources.slice";
import { getBasicDataForResourcesWithAlarms } from "../slices/dtResources.slice";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { averageConsumptionSuffix } from "Dashboard/scenes/Resources/helpers/resourceUtil";
import { alarmTypeDictionary } from "utils/translationDictionary";
import { FormatDateShort } from "utils/dateUtils";
import InfoTooltip from "components/Popup/InfoTooltip";

export const ResourcesPreview = () => {
  const { resources, loading } = useSelector(selectState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getBasicDataForResourcesWithAlarms());
  }, [dispatch]);

  return (
    <div className="daily-table-resource-alarms loading-container">
      {loading && <Loader />}
      <div className="classicHeader">
        <span className="bolded">RESURSI</span>
        <span> - alarmi</span>
      </div>
      <div className="previewBody">
        {resources.map((resource: IResourcesAlarm) => (
          <div className="singleResource">
            <InfoTooltip
              tooltip={resource.resourceName}
              classesProp="daily-table-resource-alarms-name text-overflow darkred"
              element="span"
            >
              {resource.resourceName}
            </InfoTooltip>
            <span className="daily-table-resource-alarms-consumption text-overflow">
              {">"}
              {FormatDateShort(resource.consumptionDateFrom)} - {FormatDateShort(resource.consumptionDateTo)} -{" "}
              {FormatNumberWithUnitOrNull(resource.distance, resource.usageUnit.name)} -{" "}
              {FormatNumberWithUnitOrNull(resource.averageConsumption, averageConsumptionSuffix(resource.usageUnit))}
            </span>
            {resource.alarms.map(alarm => (
              <>
                <span className="daily-table-resource-alarms-alarm-amount">{FormatNumberWithUnitOrNull(alarm.dueAmount, alarm.unit.name)}</span>
                <span className="daily-table-resource-alarms-alarm-label">do {alarmTypeDictionary[alarm.alarmType]}</span>
              </>
            ))}
            {resource.alarms.length > 0 &&
              <FontAwesomeIcon className="daily-table-resource-alarms-alarm-icon" icon={faMusic} />
            }
          </div>
        ))}
        {resources.length < 4 && <div className="singleResource"></div>}
        {resources.length < 3 && <div className="singleResource"></div>}
        {resources.length < 2 && <div className="singleResource"></div>}
        {resources.length < 1 && <div className="singleResource"></div>}
      </div>
    </div>
  );
};
